<template>
  <form @submit.prevent="onSubmit" class="bg-white p-4">
    <b-row>
      <!-- TABS -->
      <b-col md="12">
        <CustomNav
          class="mb-4"
          :items="tabsForm"
          @item-click="(tab) => (activeTab = tab)"
        />
      </b-col>
    </b-row>
    <b-row v-show="activeTab == 'general'">
      <b-col md="12">
        <div class="mb-5 d-flex justify-content-end">
          <b-button
            v-if="localIsDetail && editId"
            variant="primary"
            @click="toggleEdit"
          >
            <i class="fa fa-pencil-square-o ml-2 text-white"></i>
            Update Data
          </b-button>
          <b-button
            v-else-if="!localIsDetail && editId && !is_draft"
            variant="primary"
            @click="toggleEdit"
          >
            <i class="fa fa-floppy-o ml-2 text-white" aria-hidden="true"></i>
            Save Update
          </b-button>
        </div>
      </b-col>
      <b-col md="6">
        <!-- PROJECT PLAN -->
        <section class="mb-4">
          <div class="section-title">
            <h5>PROJECT PLAN</h5>
          </div>

          <!-- DETAIL VIEW TABLE -->
          <template v-if="localIsDetail">
            <DetailProjectPlan
              :data="dataDetailShipmentPlan"
              :optionsCompanies="optionsCompanies"
              :fleetOwnershipOptions="fleetOwnershipOptions"
              :fleetTypeOptions="fleetTypeOptions"
              :contractTypeOptions="contractTypeOptions"
              :termOptions="termOptions"
              :optionsCargoType="optionsCargoType"
              :optionUnit="optionUnit"
            />
          </template>

          <b-row v-else>
            <b-col md="6">
              <b-form-group label-for="company_id">
                <template #label>
                  <div>
                    Subject
                    <span class="text-red">*</span>
                  </div>
                </template>
                <b-form-input
                  class="w-100"
                  placeholder="Subject"
                  v-model="form.subject"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="company_id">
                <template #label>
                  <div>
                    Company
                    <span class="text-red">*</span>
                  </div>
                </template>
                <b-form-select
                  id="company_id"
                  v-model="form.company_id"
                  :options="optionsCompanies"
                  plain
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="priority">
                <template #label>
                  <div>
                    Priority
                    <span class="text-red">*</span>
                  </div>
                </template>
                <b-form-select
                  id="priority"
                  v-model="form.priority"
                  :options="[
                    { value: 1, text: 'Low' },
                    { value: 2, text: 'Medium' },
                    { value: 3, text: 'High' },
                    { value: 5, text: 'Normal (Default)' },
                  ]"
                  plain
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Fleet Ownership">
                <b-form-select
                  v-model="form.fleet_ownership"
                  :options="fleetOwnershipOptions"
                  plain
                />
              </b-form-group>
            </b-col>

            <b-col md="2" class="pr-0">
              <b-form-group label="Use Third Party">
                <b-form-checkbox switch v-model="form.third_party">
                  {{ form.third_party ? 'Yes' : 'No' }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="4" class="d-flex align-items-end pb-4 pl-0">
              <b-form-group label="Third Party Company" class="w-100">
                <template #label>
                  <div>
                    Third Party Company
                    <span class="text-red">*</span>
                  </div>
                </template>
                <b-form-input
                  class="w-100"
                  placeholder="Third Party Company"
                  :disabled="!form.third_party"
                  v-model="form.third_party_company"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Fleet Type">
                <div class="d-flex align-items-center">
                  <v-multiselect
                    v-model="form.fleet_type_ids"
                    :options="fleetTypeOptions"
                    :multiple="true"
                    placeholder="Select Fleet Type"
                    track-by="value"
                    label="text"
                    @input="onFleetTypeChange"
                  >
                    <span slot="noResult">
                      Oops! No elements found. Consider changing the search
                      query.
                    </span>
                  </v-multiselect>
                  <b-button
                    v-if="form.fleet_type_ids && form.fleet_type_ids.length > 0"
                    variant="outline-secondary"
                    size="sm"
                    @click="clearAllFleetTypes"
                    class="ml-2"
                    title="Clear All"
                  >
                    <i class="fa fa-times"></i>
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Period">
                <date-picker
                  v-model="form.period"
                  placeholder="Select Period"
                  value-type="YYYY-MM-DD"
                  class="w-100"
                  range
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Contract Type *">
                <template #label>
                  <div>
                    Contract Type
                    <span class="text-red">*</span>
                  </div>
                </template>
                <b-form-select
                  v-model="form.contract_type_id"
                  :options="contractTypeOptions"
                  plain
                />
              </b-form-group>
              <template
                v-if="
                  form.contract_type_id && selectedContractType && !isDetail
                "
              >
                <div
                  class="alert alert-primary d-flex align-items-center p-1 px-2"
                  role="alert"
                >
                  <i class="fa fa-exclamation-circle mr-2"></i>
                  <small
                    v-if="selectedContractType.is_spal === 1"
                    class="font-semibold"
                  >
                    This type using SPAL
                  </small>
                  <small v-else class="font-semibold">
                    This type not using SPAL
                  </small>
                </div>
              </template>
            </b-col>

            <b-col md="2">
              <b-form-group label="PFA">
                <b-form-checkbox switch v-model="form.is_pfa">
                  {{ form.is_pfa ? 'Yes' : 'No' }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Cargo Type">
                <b-form-select
                  v-model="form.cargo_type_id"
                  :options="optionsCargoType"
                  plain
                  @change="onChangeCargoType"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Total Quantity">
                <b-input-group>
                  <b-form-input
                    type="number"
                    disabled
                    :value="totalQuantityAdd"
                  />
                  <b-input-group-append>
                    <b-dropdown
                      right
                      variant="outline-secondary"
                      :text="
                        optionUnit.find((el) => el.value === form.unit)?.text
                      "
                      toggle-class="text-dark"
                      size="sm"
                    >
                      <b-dropdown-item
                        v-for="(unit, index) in optionUnit"
                        :key="index"
                        @click="form.unit = unit?.value"
                      >
                        {{ unit?.text }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Term">
                <b-form-select
                  v-model="form.term"
                  :options="termOptions"
                  @change="onTermChange"
                  plain
                />
              </b-form-group>
            </b-col>
            <b-col md="4" class="d-flex align-items-end pb-3 pl-0">
              <b-form-group label="Term Description" class="w-100">
                <b-form-input type="text" v-model="form.termDescription" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Laycan">
                <date-picker
                  v-model="form.laycan"
                  placeholder="Select Laycan"
                  value-type="YYYY-MM-DD"
                  class="w-100"
                  range
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Distance (NM)">
                <InputCurrency
                  type="number"
                  v-model="form.distance"
                  prepend=""
                  append="NM"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Currency">
                <b-form-select
                  :options="currencyOptions"
                  v-model="form.currency_id"
                  @change="onCurrencyChange"
                  plain
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Currency Rate">
                <InputCurrency
                  v-model="form.currencyRate"
                  prepend=""
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Est. Freight Rate">
                <InputCurrency
                  :prepend="
                    currencyOptions.find((el) => el.value == form.currency_id)
                      ?.text
                  "
                  v-model="form.freightRate"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" class="pb-4 d-flex align-items-end px-0">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="ppn"
                  v-model="form.isPpn"
                ></b-form-checkbox>
                <label for="ppn" class="mb-0 text-nowrap">Include PPN</label>
              </div>
            </b-col>
            <b-col md="12">
              <b-form-group label="Remarks">
                <b-form-textarea v-model="form.remarks" plain />
              </b-form-group>
            </b-col>
          </b-row>
        </section>
        <!-- APPROVAL -->
        <section class="mb-5">
          <div class="section-title">
            <h5>APPROVAL</h5>
          </div>
          <ApprovalProject
            v-if="hasLoadApprovalOrBusdevTeams"
            :approvalOptions="approvalOptions"
            :approvals="approvals"
            :isDetail="localIsDetail"
            @update:approvals="onApprovalsChange"
            :profileId="userProfileId"
          />
        </section>

        <!-- BUSDEV TEAM -->
        <section class="mb-5">
          <div
            class="section-title d-flex align-items-center justify-content-between"
          >
            <h5>BUSDEV TEAM</h5>
          </div>
          <ApprovalProject
            v-if="hasLoadApprovalOrBusdevTeams"
            :approvalOptions="approvalOptions"
            :approvals="busdevTeam"
            :isDetail="localIsDetail"
            @update:approvals="(val) => (busdevTeam = val)"
          />
        </section>
      </b-col>

      <!-- RIGHT PANEL -->
      <b-col md="6" class="pl-4">
        <!-- CUSTOMER INFO -->
        <CustomerInfoSection
          class="mb-5"
          v-model="form.customerInfo"
          :customerOptions="customerOptions"
          :isDetail="localIsDetail"
          @refecthCustomerList="fetchCustomerProspects"
        />

        <div class="mb-5">
          <div class="section-title">
            <h5>PORT</h5>
          </div>
          <TablePortProject
            class="mt-3"
            :form="form"
            :polOptions="positionListTextPOL"
            :podOptions="positionListTextPOD"
            :isDetail="localIsDetail"
          />
        </div>

        <!-- TENDER -->
        <section class="mb-5">
          <div class="section-title">
            <h5>TENDER</h5>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group label="PIC">
                <template v-if="!localIsDetail">
                  <b-form-input v-model="form.tenderPic" plain />
                </template>
                <template v-else>
                  <p class="form-control-plaintext font-semibold">
                    {{ form.tenderPic || '-' }}
                  </p>
                </template>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Url">
                <template v-if="!localIsDetail">
                  <b-form-input v-model="form.tenderUrl" plain />
                </template>
                <template v-else>
                  <p class="form-control-plaintext font-semibold">
                    {{ form.tenderUrl || '-' }}
                  </p>
                </template>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Attachment">
                <template v-if="!localIsDetail">
                  <b-form-file multiple v-model="form.tenderAttachment" />
                </template>
                <template v-else>
                  <div v-if="form.tenderAttachment?.length > 0">
                    <button
                      type="button"
                      class="btn btn-link p-0 form-control-plaintext text-left"
                      v-for="(file, index) in form.tenderAttachment"
                      :key="index"
                      @click="openTenderFile(file)"
                    >
                      {{
                        file.url?.split('/')[file.url?.split('/').length - 1]
                      }}
                    </button>
                  </div>
                </template>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Description">
                <template v-if="!localIsDetail">
                  <b-form-textarea v-model="form.tenderDescription" plain />
                </template>
                <template v-else>
                  <p class="form-control-plaintext font-semibold">
                    {{ form.tenderDescription || '-' }}
                  </p>
                </template>
              </b-form-group>
            </b-col>
          </b-row>
        </section>

        <!-- <div class="mb-5">
          <div class="section-title">
            <h5>PROJECT INFO</h5>
          </div>
          <ProjectInfo />
        </div>

        <div>
          <div class="section-title">
            <h5>CUSTOMER INFO</h5>
          </div>
          <CustomerInfo />
        </div> -->
      </b-col>
    </b-row>
    <!-- SPAL / CONTRACT TAB -->
    <b-row v-show="activeTab == 'spal'">
      <b-col md="12">
        <SpalSection
          v-if="activeTab == 'spal'"
          v-model="spalModel"
          :data="form.spal_process"
          :project="spalProjectInfo"
          :customer="spalCustomerInfo"
          :isDetail="localIsDetail"
          :editId="editId"
          :required="true"
        />
      </b-col>
    </b-row>
    <div v-show="activeTab == 'shipment-plan'">
      <DetailShipmentPlan
        :generateShipmentPlanNumber="generateShipmentPlanNumber"
        :form="form"
        :optionsFleetTypes="fleetTypeOptions"
        :optionsCargoType="optionsCargoType"
        :optionsTerm="termOptions"
        :optionsProjectTerms="optionsProjectTerms"
        :positionListTextPOD="positionListTextPOD"
        :positionListTextPOL="positionListTextPOL"
        :fleetOptions="fleetOptions"
        :isDetail="localIsDetail"
        @cancel-update="toggleEdit"
        @submit="onSubmit"
      />
    </div>
    <div v-show="activeTab == 'document'">
      <formProjectDocument
        :form="form"
        :isDetail="localIsDetail"
        :shipmentNumberOptions="shipmentNumberOptions"
        @submit="onSubmit"
      />
    </div>
    <div v-show="activeTab == 'pfa'">
      <!-- <PfaUploader v-model="formState.pfa" /> -->
      <SlideFormPFA
        v-if="activeTab === 'pfa'"
        :pfa-action="'EDIT'"
        :pfa-id="editId"
        :data-project="dataProject"
        :options-fleets="optionsFleets"
        :optionsCargoType="optionsCargoType"
        :fleetTypeOptions="fleetTypeOptions"
        :is-reset="false"
      />
    </div>
    <div v-show="activeTab == 'trip_document'">
      <TripDocumentTable
        v-if="activeTab == 'trip_document'"
        v-model="formState.tripDocuments"
        :data-project="form"
        @refresh="loadDetailFromTable"
      />
    </div>
    <div v-show="activeTab == 'payment_list'">
      <PaymentListTable
        v-model="formState.paymentList"
        :projectId="editId"
        :projectData="projectDataForSidebar"
        :optionsProjectTerms="optionsProjectTerms"
        :positionListTextPOD="positionListTextPOD"
        :positionListTextPOL="positionListTextPOL"
        :optionsFleetTypes="fleetTypeOptions"
        :optionsCargoType="optionsCargoType"
        :fleetOptions="fleetOptions"
        :refreshData="fetchPaymentLists"
      />
    </div>
    <div v-show="activeTab == 'real_shipment'">
      <TabRealShipmentNew
        v-if="activeTab == 'real_shipment'"
        :projectData="form"
        :optionsFleets="optionsFleets"
      />
    </div>
    <div v-if="!localIsDetail" class="w-100 d-flex mt-4">
      <b-button
        class="mr-2 w-50"
        variant="outline-primary"
        @click="$emit('close')"
      >
        Cancel
      </b-button>
      <b-button v-if="is_draft" class="w-50 mr-2" type="button" variant="primary" :disabled="saving" @click="onSubmit(false, true)">
        Save as Draft
      </b-button>
      <b-button class="w-50" type="submit" variant="primary" :disabled="saving">
        Submit
      </b-button>
    </div>
  </form>
</template>
<script>
import CustomNav from '@/src/components/global/CustomNav.vue'
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import {
  busdevActions,
  crewingActions,
  fleetsActions,
  portsActions,
} from '@/src/Utils/helper'
import CustomerInfo from '../FormSections/CustomerInfo.vue'
import ProjectInfo from '../FormSections/ProjectInfo.vue'
import ApprovalProject from '../FormSections/ApprovalProject.vue'
import TablePortProject from '../FormSections/TablePortProject.vue'
import DetailShipmentPlan from '../FormSections/DetailShipmentPlan.vue'
import CustomerInfoSection from './FormSections/CustomerInfoSection.vue'
import FormProjectDocument from '../components/FormProjectDocument.vue'
import PfaUploader from './components/PfaUploader.vue'
import TripDocumentTable from './components/TripDocumentTable.vue'
import PaymentListTable from './components/PaymentListTable.vue'
import DetailProjectPlan from './components/DetailProjectPlan.vue'
import moment from '@/node_modules/moment/moment'
import hmacClient from '@/src/services/hmacClient'
import SlideFormPFA from './SlideFormPFA.vue'
const TabRealShipmentNew = () => import('./TabRealShipmentNew.vue')

export default {
  props: {
    editId: {
      type: [Number, String],
      default: null,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    optionsCompanies: {
      type: Array,
      default: () => [],
    },
    optionsFleets: {
      type: Array,
      default: true,
    },
  },
  components: {
    CustomNav,
    InputCurrency,
    CustomerInfo,
    ProjectInfo,
    ApprovalProject,
    TablePortProject,
    DetailShipmentPlan,
    CustomerInfoSection,
    FormProjectDocument,
    PfaUploader,
    TripDocumentTable,
    PaymentListTable,
    DetailProjectPlan,
    SpalSection: () => import('./Spal/SpalSection.vue'),
    SlideFormPFA,
    TabRealShipmentNew,
  },
  data() {
    return {
      userProfileId: JSON.parse(localStorage.getItem('profile')).id,
      localIsDetail: false,
      prevFleetTypeIds: [],
      activeTab: 'general',
      defaultTabsForm: [
        {
          label: 'GENERAL',
          value: 'general',
        },
        {
          label: 'DETAIL SHIPMENT PLAN',
          value: 'shipment-plan',
        },
        {
          label: 'SUPPORT DOCUMENT',
          value: 'document',
        },
      ],
      dataDetailShipmentPlan: null,
      form: {
        project_name: '',
        shipment_plan_number: '',
        contract_type: null,
        customerInfo: {
          customerType: 'active',
          customerActive: null,
          customer_active_id_pfat: null,
          customer_prospect_id_pfat: null,
          companyName: '',
          website: '',
          email: '',
          country: '',
          province: '',
          city: '',
          address: '',
          npwp: '',
          nib: '',
          picName: '',
          picPhone: '',
          picEmail: '',
          customerInfoForm: null,
        },
        isPpn: false,
        priority: 5,
        ports: [{ pol: null, polOther: '', pod: null, podOther: '' }],
        company: '',
        fleet_ownership: 'own-ship',
        third_party: false,
        third_party_company: '',
        fleet_type_ids: [],
        period: [],
        contractType: '',
        is_pfa: false,
        cargo_type_id: '',
        totalQuantity: 0,
        unit: '',
        term: '',
        termDescription: '',
        laycan: [],
        distance: 0,
        currencyRate: 0,
        freightRate: 0,
        currency_id: 'IDR',
        remarks: '',
        tenderPic: '',
        tenderUrl: '',
        tenderAttachment: null,
        tenderDescription: '',
        // SPAL fields
        spal_title: '',
        spal_notes: '',
        spal_file: null,
        spal_file_url: '',
        spal_fix: false,
        project_type: 'none', // new_project, existing, none
        project_id: null,
        detail_plan: [
          // {
          //   shipment_plan_detail_number: '',
          //   status: 'plan',
          //   description: '',
          //   fleet_ownership: 'own-ship',
          //   fleet_type_id: null,
          //   fleets: [],
          //   cargo_type_id: null,
          //   terms_id: null,
          //   terms_remarks: '',
          //   pol: [{ value: '', valueOther: '' }],
          //   pod: [{ value: '', valueOther: '' }],
          //   shipment: '',
          //   eta_pol: '',
          //   eta_pod: '',
          //   plan_quantity: null,
          //   remarks: '',
          //   acceptance_date: null,
          //   draught_type: 'draught_survey_loading',
          // },
        ],
        documents: [
          {
            fileName: '',
            file: null,
          },
        ],
        spal_process: [],
      },
      // New temporary state before backend ready
      formState: {
        pfa: { file: null, fileName: '' },
        tripDocuments: [],
        paymentList: [],
      },
      unit_others: false,
      approvals: [],
      busdevTeam: [],
      optionsApproval: [],
      optionsCargoType: [],
      approvalOptions: [],
      busdevTeamOptions: [],
      positionListTextPOD: [],
      positionListTextPOL: [],
      optionsProjectTerms: [],
      listProjectStage: [],
      fleetOptions: [],
      fleetOwnershipOptions: [
        { text: 'Own Ship', value: 'own-ship' },
        { text: 'Chartered', value: 'chartered' },
      ],
      fleetTypeOptions: [],
      contractTypeOptions: ['Spot Freight Charter', 'Time Charter'],
      portOptions: ['Bengalon', 'Paiton', 'Balikpapan'],

      optionUnit: [],
      currencyOptions: [],
      saving: false,
      termOptions: [],
      listCustomerActive: [],
      listCustomerProspect: [],
      apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,
      is_draft: true,
      hasLoadApprovalOrBusdevTeams: false
    }
  },
  computed: {
    spalModel: {
      get() {
        return {
          title: this.form.spal_title,
          notes: this.form.spal_notes,
          file: this.form.spal_file,
          fix: this.form.spal_fix,
        }
      },
      set(v) {
        this.form.spal_title = v?.title || ''
        this.form.spal_notes = v?.notes || ''
        this.form.spal_file = v?.file || null
        this.form.spal_fix = !!v?.fix
      },
    },
    spalPreviewData() {
      return {
        title: this.form.spal_title,
        notes: this.form.spal_notes,
        fileUrl: this.form.spal_file_url,
        fix: this.form.spal_fix,
      }
    },
    spalProjectInfo() {
      console.log(this.form, 'FORM')
      return [
        { label: 'Project', value: this.form.project_name },
        {
          label: 'Company Name',
          value: this.optionsCompanies.find(
            (el) => el.value === this.form.company_id
          )?.text,
        },
        {
          label: 'Fleet Ownership',
          value: this.fleetOwnershipOptions.find(
            (el) => el.value === this.form.fleet_ownership
          )?.text,
        },
        {
          label: 'Fleet Type',
          value: (this.form.fleet_type_ids || []).map((i) => i.text).join(', '),
        },
        {
          label: 'Period',
          value:
            this.form.period && this.form.period.length === 2
              ? `${this.moment(this.form.period[0]).format(
                  'DD/MM/YYYY'
                )} - ${this.moment(this.form.period[1]).format('DD/MM/YYYY')}`
              : '-',
        },
        {
          label: 'Shipment Plan Number',
          value: this.form.shipment_plan_number,
        },
        {
          label: 'Contract Type',
          value:
            this.contractTypeOptions.find(
              (el) => el.value === this.form.contract_type_id
            )?.text || this.selectedContractType?.name,
          is_spal:
            this.contractTypeOptions.find(
              (el) => el.value === this.form.contract_type_id
            )?.is_spal || this.selectedContractType?.is_spal,
        },
        // Additional details to mirror SPAL project info
        {
          label: 'Term',
          value: (() => {
            const t = this.termOptions.find(
              (el) => el.value === this.form.term
            )?.text
            return t
              ? `${t}${
                  this.form.termDescription
                    ? ' (' + this.form.termDescription + ')'
                    : ''
                }`
              : this.form.termDescription || '-'
          })(),
        },
        {
          label: 'Port of Loading',
          value:
            this.form.ports && this.form.ports[0]?.pol
              ? this.form.ports[0].pol
              : '-',
        },
        {
          label: 'Port of Discharging',
          value:
            this.form.ports && this.form.ports[0]?.pod
              ? this.form.ports[0].pod
              : '-',
        },
        { label: 'Distance', value: this.form.distance || '-' },
        {
          label: 'Laycan',
          value:
            this.form.laycan && this.form.laycan.length === 2
              ? `${this.moment(this.form.laycan[0]).format(
                  'DD/MM/YYYY'
                )} - ${this.moment(this.form.laycan[1]).format('DD/MM/YYYY')}`
              : '-',
        },
        {
          label: 'Cargo Type',
          value:
            this.optionsCargoType.find(
              (el) => el.value === this.form.cargo_type_id
            )?.text || '-',
        },
        {
          label: 'Total Plan QTY',
          value: (() => {
            const qty = this.totalQuantityAdd
            const unit =
              this.optionUnit.find((el) => el.value === this.form.unit)?.text ||
              ''
            return qty
              ? `${
                  this.$options.filters?.number
                    ? this.$options.filters.number(qty)
                    : qty
                } ${unit}`
              : '-'
          })(),
        },
        { label: 'Remarks', value: this.form.remarks || '-' },
      ]
    },
    spalCustomerInfo() {
      return this.form.customerInfo
    },
    totalQuantityAdd() {
      return this.form.detail_plan.reduce(
        (total, item) => total + Number(item.plan_quantity),
        0
      )
    },
    customerOptions() {
      if (this.form.customerInfo.customerType === 'active') {
        return this.listCustomerActive
      } else {
        return this.listCustomerProspect
      }
    },
    selectedContractType() {
      return this.contractTypeOptions.find(
        (el) => el.id === this.form.contract_type_id
      )
    },
    selectedFleetTypes() {
      if (
        !this.form.fleet_type_ids ||
        !Array.isArray(this.form.fleet_type_ids)
      ) {
        return []
      }
      return this.form.fleet_type_ids
        .map((typeId) => {
          const option =
            this.fleetTypeOptions.find((option) => option.value === typeId) ||
            this.fleetTypeOptions.find((option) => option.id === typeId)
          return option
            ? {
                value: option.value || option.id,
                text: option.text || option.name,
              }
            : null
        })
        .filter(Boolean)
    },
    tabsForm() {
      let defaultTabs = this.defaultTabsForm
      if (this.isDetail) {
        defaultTabs = [
          ...defaultTabs,
          {
            label: 'PFA',
            value: 'pfa',
          },
          {
            label: 'SPAL PROCESS',
            value: 'spal',
          },
          {
            label: 'TRIP DOCUMENT',
            value: 'trip_document',
          },
          {
            label: 'REAL SHIPMENT',
            value: 'real_shipment',
          },
          {
            label: 'PAYMENT LIST',
            value: 'payment_list',
          },
        ]
      }
      if (!this?.dataDetailShipmentPlan?.contract_type?.is_spal) {
        defaultTabs = defaultTabs.filter((tab) => tab.value !== 'spal')
      }
      return defaultTabs
    },
    projectDataForSidebar() {
      console.log(this.form, 'FORM PROJECT PLAN')
      // Build minimal project data expected by SlidePaymentList when adding payments
      // const plans = (this.form?.detail_plan || []).map(dp => ({
      //   ...dp,
      //   id: dp.id,
      //   shipment_plan_detail_number: dp.shipment_plan_detail_number || dp.number || dp?.shipment_plan_number,
      //   description: dp.description,
      //   fleet_ownership: this.form?.fleet_ownership,
      //   fleet_type: { name: (this.fleetTypeOptions || []).find(ft => ft.value === (dp.fleet_type_id || this.form?.fleet_type_id))?.text },
      //   fleets: dp.fleets || [],
      //   cargo_type: { name: (this.optionsCargoType || []).find(ct => ct.value === (dp.cargo_type_id || this.form?.cargo_type_id))?.text },
      //   plan_quantity: dp.plan_quantity,
      //   unit: this.optionUnit?.find(u => u.value === (dp.unit || this.form?.unit))?.text,
      //   acc_date: dp.acc_date,
      // }))
      return {
        ...this.form,
        customer_id: this.form.customer_active_id_pfat,
        currency_id: this.form.currency_id,
        third_party: this.form?.third_party || false,
        project_contract_plan: this.form?.detail_plan,
      }
    },
    shipmentNumberOptions() {
      if (!this.form.detail_plan || !Array.isArray(this.form.detail_plan)) {
        return []
      }

      return this.form.detail_plan
        .map((plan, index) => {
          const shipmentPlanNumber = this.generateShipmentPlanNumber(
            this.form,
            plan,
            index
          )

          return {
            value: shipmentPlanNumber,
            text: `${shipmentPlanNumber}`,
            planData: plan,
            index: index,
          }
        })
        .filter(
          (option) => option.value && option.value !== 'Choose fleet first.'
        )
    },
  },
  methods: {
    ...busdevActions,
    ...crewingActions,
    ...fleetsActions,
    ...portsActions,
    async openTenderFile(file) {
      try {
        const fileUrl = file?.url || ''
        const url = `${this.apiUrl}/download/${fileUrl.replace('upload/', '')}`
        // Reuse authenticated axios instance from auth store like in FormProjectDocument
        const axios = this.$store?.state?.authAxios || this.$axios || this.$http
        const res = await axios.get(url, { responseType: 'blob' })
        const blobUrl = URL.createObjectURL(res.data)
        window.open(blobUrl, '_blank')
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
      } catch (err) {
        alert(err?.message || 'Failed to open attachment')
      }
    },
    onApprovalsChange(val) {
      this.approvals = Array.isArray(val) ? val : []
    },
    onFleetTypeChange(selectedFleetTypes) {
      if (!selectedFleetTypes || !Array.isArray(selectedFleetTypes)) {
        return
      }

      // Fleet type pairs yang saling terkait (pilih/hapus salah satu = keduanya)
      const fleetTypePairs = {
        1: 2, // TUG BOAT (1) <-> BARGE (2)
        2: 1, // BARGE (2) <-> TUG BOAT (1)
        4: 5, // PUSHER TUG (4) <-> PUSHER BARGE (5)
        5: 4, // PUSHER BARGE (5) <-> PUSHER TUG (4)
      }

      const prevVals = (this.prevFleetTypeIds || []).map((x) => x.value)
      const newVals = selectedFleetTypes.map((x) => x.value)
      const addedVals = newVals.filter((v) => !prevVals.includes(v))
      const removedVals = prevVals.filter((v) => !newVals.includes(v))

      let result = [...selectedFleetTypes]

      // Item ditambah -> auto-add pasangannya
      addedVals.forEach((v) => {
        const paired = fleetTypePairs[v]
        if (paired && !result.some((x) => x.value === paired)) {
          const opt = this.fleetTypeOptions.find((o) => o.value === paired)
          if (opt) result.push(opt)
        }
      })

      // Item dihapus -> auto-remove pasangannya
      removedVals.forEach((v) => {
        const paired = fleetTypePairs[v]
        if (paired) {
          result = result.filter((x) => x.value !== paired)
        }
      })

      // Simpan snapshot untuk diff berikutnya
      this.prevFleetTypeIds = [...result]

      // Reassign hanya bila hasil berbeda dari emit (ada pair ditambah/dihapus);
      // reassign tiap @input mendesync vue-multiselect. Defer via nextTick.
      if (result.length !== selectedFleetTypes.length) {
        this.$nextTick(() => {
          this.form.fleet_type_ids = result
        })
      }
    },
    clearAllFleetTypes() {
      this.form.fleet_type_ids = []
      this.prevFleetTypeIds = []
    },
    async getTerms() {
      let res = await this.fetchTerms()
      if (res.data.status === true && res.data.data.length > 0) {
        res.data.data.map((state) => {
          this.termOptions.push({
            value: state.id,
            text: state?.name,
            description: state?.description,
          })
        })
      }
    },

    onTermChange() {
      const selected = this.termOptions.find(
        (el) => el.value === this.form.term
      )
      this.form.termDescription = selected?.description || ''
    },
    formatNumber(num) {
      return num.toString().padStart(4, '0')
    },

    generateShipmentPlanNumber(form, dataShipment, index) {
      // Check if we have dataShipment with fleet_id
      if (!dataShipment || !dataShipment.fleet_id) {
        return 'Choose fleet first.'
      }

      // Helper function to clean fleet name
      const cleanFleetName = (name) => {
        if (!name) return ''
        // Remove semicolons, colons, spaces, strips, and dots, then convert to uppercase
        return name.replace(/[;:\s\-.]/g, '').toUpperCase()
      }

      // Get fleet names from fleetOptions
      const fleet1 = this.fleetOptions.find(
        (fleet) => fleet.value === dataShipment.fleet_id
      )
      const fleet2 = dataShipment.second_fleet_id
        ? this.fleetOptions.find(
            (fleet) => fleet.value === dataShipment.second_fleet_id
          )
        : null

      // Clean fleet names
      const fleet1Name = cleanFleetName(fleet1?.text || '')
      const fleet2Name = fleet2 ? cleanFleetName(fleet2.text || '') : ''

      // Build fleet string
      const fleetString = fleet2Name
        ? `${fleet1Name}-${fleet2Name}`
        : fleet1Name

      // Format current date as DDMMYY (6 digits)
      const currentDate = moment().format('DDMMYY')

      // Format index with leading zeros (3 digits: 001, 002, etc.)
      const formattedIndex = (index + 1).toString().padStart(3, '0')

      // Return format: FLEET1-FLEET2-061125-001 or FLEET1-061125-001
      return `${fleetString}-${currentDate}-${formattedIndex}`
    },

    handleDeletePort(index) {
      this.form.ports.splice(index, 1)
    },

    addPort() {
      this.form.ports.push({ pol: null, pod: null })
    },

    async getPortList() {
      let params = {
        active: true,
        page: 1,
        perPage: 9999999,
      }
      const res = await this.getPorts(params)
      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach((val) => {
            if (val.portType === 'LOADING_PORT') {
              this.positionListTextPOL.push({
                value: val.portName,
                text: `${val.portName}`,
                ...val,
              })
            } else if (val.portType === 'DISCHARGING_PORT') {
              this.positionListTextPOD.push({
                value: val.portName,
                text: `${val.portName}`,
                ...val,
              })
            }
          })
          this.positionListTextPOD.push({
            value: 'other',
            text: `Other`,
          })
          this.positionListTextPOL.push({
            value: 'other',
            text: `Other`,
          })
        }
      } else {
        this.$swal(`Oops!`, res.data.data, 'error')
      }
    },

    async getCurrency() {
      // Fetch via reusable Vuex action using the new endpoint
      const res = await this.fetchConfigCurrencies()
      if (res.status === 'success') {
        const payload = res.data
        const list = payload?.data || payload || []
        if (Array.isArray(list) && list.length > 0) {
          this.currencyOptions = list.map((state) => {
            console.log(parseInt(state?.currency_rate), 'state?.currency_rate')
            return {
              value: state.from_currency_id,
              text: state?.from_currency?.currency,
              currency_rate: state?.currency_rate
                ? parseFloat(state?.currency_rate).toString()
                : 0,
            }
          })
        }
      }

      this.form.currency_id = this.currencyOptions?.find(
        (obj) => obj.text === 'IDR'
      )?.value
      this.form.currencyRate = this.currencyOptions?.find(
        (obj) => obj.text === 'IDR'
      )?.currency_rate
    },

    onCurrencyChange() {
      const selected = this.currencyOptions.find(
        (el) => el.value === this.form.currency_id
      )
      this.form.currencyRate = selected?.currency_rate || 0
    },

    // Formatting methods for detail view
    formatCurrency(value) {
      if (!value) return '0'
      return new Intl.NumberFormat('id-ID').format(value)
    },

    formatDateRange(startDate, endDate) {
      if (!startDate && !endDate) return '-'
      if (!startDate) return moment(endDate).format('DD/MM/YYYY')
      if (!endDate) return moment(startDate).format('DD/MM/YYYY')
      return `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
        endDate
      ).format('DD/MM/YYYY')}`
    },

    async fetchDataUserExpert() {
      let params = {
        page: 1,
        active: true,
        perPage: 200,
      }
      const { status, data } = await this.fetchUserExpert(params)

      if (status) {
        if (data && data.length > 0) {
          data.map((state) => {
            this.approvalOptions.push({
              value: state.id,
              text: state.userDetail?.name,
              photo: state.userDetail?.photo,
              email: state.email,
              position: state.userDetail?.position,
            })
            const profile = localStorage.getItem('profile')
              ? JSON.parse(localStorage.getItem('profile'))
              : null
            for (let i = 0; i < this.approvalOptions.length; i++) {
              if (profile && this.approvalOptions[i].value === profile.id) {
                this.busdevTeam = [
                  {
                    ...this.approvalOptions[i],
                    approval_id: this.approvalOptions[i].value,
                  },
                ]
                break
              }
            }
          })
        }
      }
    },

    async getVehicleType() {
      this.optionsFleetTypes = []
      let { status, data } = await this.getFleetTypes()

      if (status === 'success') {
        this.optionsFleetTypes = data.map((val) => {
          return {
            ...val,
            value: val.id,
            text: val?.name,
          }
        })
      }
    },

    async getCargoType() {
      let res = await this.fetchCargoType()
      if (res.data.status === true && res.data.data.length > 0) {
        res.data.data.map((state) => {
          this.optionsCargoType.push({
            ...state,
            value: state.id,
            text: state?.name,
          })
        })
      }
    },

    async getListProjectTerms() {
      this.optionsProjectTerms = []
      let params = {
        page: 1,
        perPage: 100000,
        status: 1,
      }

      let res = await this.fetcBusdevMProjTerms(params)

      if (res.data.status === true && res.data.data?.data.length > 0) {
        res.data.data?.data.map((val) => {
          this.optionsProjectTerms?.push({
            value: val.id,
            text: `${val?.name}`,
          })
        })
      }
    },

    async fetchFleets(ownership) {
      let params = this.$options.filters.cleanObject({
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
        ownership,
      })

      if (!params.ownership) delete params.ownership

      let res = await this.getFleets(params)

      if (res.status) {
        if (res.data && res.data.length > 0) {
          this.fleetOptions = res.data.map((val) => ({
            text: val?.name,
            value: val.id,
            vehicle_type_id: val.vehicleType.id,
            checked: false,
          }))
        }
      }
    },

    async getContractTypes() {
      let res = await this.fetchContractType()
      if (res.data.status === true && res.data.data.length > 0) {
        this.contractTypeOptions = res.data.data.map((state) => {
          return {
            ...state,
            value: state.id,
            text: state?.name,
          }
        })
      }
    },

    async fetchFleetTypes() {
      let params = this.$options.filters.cleanObject({
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
      })
      console.log('AAAAA')

      let res = await this.getFleetTypes(params)

      if (res.status) {
        if (res.data && res.data.length > 0) {
          this.fleetTypeOptions = res.data.map((val) => ({
            text: val?.name,
            value: val.id,
          }))
        }
      }
    },

    async getListProjectStage() {
      this.listProjectStage = []
      let res = await this.fetchDetailProjectStage()
      if (res?.status == 'success' || res.data.status == true) {
        if (res.data.data && res.data.data.length > 0) {
          this.listProjectStage = res.data.data
        }
      }
    },

    onChangeCargoType() {
      if (this.form.cargo_type_id) {
        const cargoUnit = this.optionsCargoType.find(
          (obj) => obj.id === Number(this.form.cargo_type_id)
        )

        if (cargoUnit.unit.child.length > 0) {
          console.log(cargoUnit.unit.child)
          this.form.unit = cargoUnit.unit.child[0]?.name
          this.optionUnit = cargoUnit.unit.child.map((val) => {
            return {
              text: val?.alias,
              value: val?.name,
            }
          })
          this.unit_others = false
        } else if (cargoUnit.unit.alias === 'others') {
          this.optionUnit = []
          this.form.unit = ''
          this.unit_others = true
        } else {
          this.optionUnit = []
          this.form.unit = cargoUnit.unit?.name
          this.unit_others = false
        }
      }
    },

    async handleDocumentsAndTender(projectId) {
      if (this.form.documents?.length) {
        const formData = new FormData()
        formData.append('project_contract_id', projectId)
        // Only include documents that actually have a file
        const docsWithFile = this.form.documents.filter((d) => !!d?.file)
        docsWithFile.forEach((item, indexKey) => {
          // append known fields; avoid iterating all keys blindly
          if (item.file)
            formData.append(`document[${indexKey}][file]`, item.file)
          if (item.name)
            formData.append(`document[${indexKey}][name]`, item.name)
          if (item.type)
            formData.append(`document[${indexKey}][type]`, item.type)
          if (item.shipmentPlanDetailNumber)
            formData.append(
              `document[${indexKey}][shipment_plan_number]`,
              item.shipmentPlanDetailNumber
            )
          // pass through any additional primitive fields safely
          Object.keys(item || {}).forEach((key) => {
            if (
              ['file', 'name', 'type', 'shipmentPlanDetailNumber'].includes(key)
            )
              return
            const val = item[key]
            if (
              typeof val === 'string' ||
              typeof val === 'number' ||
              typeof val === 'boolean'
            ) {
              formData.append(`document[${indexKey}][${key}]`, val)
            }
          })
        })
        if (docsWithFile.length > 0) {
          await this.createProjectContractDocument({ data: formData })
        }
      }

      if (
        this.form.tenderAttachment ||
        this.form.tenderDescription ||
        this.form.tenderPic ||
        this.form.tenderUrl
      ) {
        const formData = new FormData()
        formData.append('project_contract_id', projectId)
        formData.append('pic', this.form.tenderPic)
        formData.append('url', this.form.tenderUrl)
        formData.append('description_of_tender', this.form.tenderDescription)
        this.form.tenderAttachment?.forEach((f, i) =>
          formData.append(`file[${i}]`, f)
        )
        await this.createProjectContractTender({ data: formData })
      }
    },

    showAlert(title, text, icon) {
      this.$swal(title, text, icon)
    },

    normalizeLocationArray(arr) {
      return arr?.length > 0
        ? arr.map((v) => v)
        : [{ value: '', valueOther: '' }]
    },

    resolveProjectId() {
      if (this.project_type === 'new_project')
        return Number(this.formProject?.selected_project?.id)

      if (this.form.new_sub_project) return this.form.new_project_id

      return Number(this.form.project_sub_id)
    },

    vehicleName(id) {
      let vehicle = this.fleetOptions.find((obj) => obj.value == id)

      return vehicle?.text
    },
    findVehicleDataById(id) {
      const vehicle = this.fleetOptions.find((obj) => obj.value == id)
      return vehicle
    },
    buildPayload(saveDraft = false) {
      const f = this.form

      const formatLaycan = (date) =>
        date ? moment(date).format('YYYY-MM-DD') : null
      const formatAcceptance = (date) => {
        const accDate = moment(date)
        return accDate.isValid() ? accDate.format('YYYY-MM-DD HH:mm') : null
      }

      // Build payload only with properties that exist in form state
      let payload = {
        id: f.id || null,
        project_sub_id: f.project_sub_id || null,
        isPpn: f.isPpn,
        pol: f.ports?.map((p) => ({ value: p.pol, valueOther: p.polOther })),
        pod: f.ports?.map((p) => ({ value: p.pod, valueOther: p.podOther })),
        company_id: f.company_id || '', // using company from form
        prioritize: f.priority,
        subject: f.subject,
        contract_type_id: f.contract_type_id,
        fleet_ownership: f.fleet_ownership,
        third_party: !!f.third_party,
        third_party_company: f.third_party_company,
        fleet_type_ids: f.fleet_type_ids?.map((el) => el.value),
        period: f.period,
        period_start: f.period?.[0]
          ? moment(f.period[0]).format('YYYY-MM-DD')
          : null,
        period_end: f.period?.[1]
          ? moment(f.period[1]).format('YYYY-MM-DD')
          : null,
        contractType: f.contractType,
        is_pfa: f.is_pfa ? 1 : 0,
        cargo_type_id: f.cargo_type_id,
        totalQuantity: f.totalQuantity,
        unit: f.unit,
        term: f.term,
        termDescription: f.termDescription,
        laycan_start: formatLaycan(f.laycan?.[0]),
        laycan_end: formatLaycan(f.laycan?.[1]),
        distance: f.distance,
        currencyRate: f.currencyRate,
        freight_rate_est: f.freightRate,
        ppn: f.isPpn ? 'include' : 'exclude',
        currency_id: f.currency_id,
        remarks: f.remarks,
        tenderPic: f.tenderPic,
        tenderUrl: f.tenderUrl,
        tenderAttachment: f.tenderAttachment,
        tenderDescription: f.tenderDescription,
        project_type: f.project_type,
        project_id: f.project_id,
        detail_project_stage_id: f.detail_project_stage_id || Number(this.listProjectStage?.[0]?.id),
        total_quantity: Number(this.totalQuantityAdd),
        customer_type: f.customerInfo.customerType,
        customer_id: f.customerInfo.customerActive?.id,
        fleets: f.detail_plan?.map((val) => ({
          vehicle_id: val?.fleet_id,
          vehicle_name: this.vehicleName(val?.fleet_id),
        })),
        second_fleets: f.detail_plan?.map((val) => ({
          vehicle_id: val?.second_fleet_id,
          vehicle_name: this.vehicleName(val?.second_fleet_id),
        })),
        detail_plan: f.detail_plan?.map((val, i) => ({
          ...val,
          fleets: [
            {
              vehicle_id: val?.fleet_id,
            },
          ],
          fleet_type_id: this.findVehicleDataById(val?.fleet_id)?.vehicleType
            ?.vehicle_type_id,
          acceptance_date: formatAcceptance(val.acceptance_date),
          pol: val.pol?.map((p) => ({
            value: p.value,
            valueOther: p.valueOther,
          })),
          pod: val.pod?.map((p) => ({
            value: p.value,
            valueOther: p.valueOther,
          })),
          shipment_plan_detail_number: this.generateShipmentPlanNumber(
            f,
            val,
            i
          ),
        })),
        user_approval: this.approvals?.map((val) => {
          let userExpert = this.approvalOptions.find(
            (obj) => obj.value == val.approval_id
          )
          if (val.approval_id && userExpert) {
            return {
              id: val.approval_id,
              email: userExpert?.email,
              name: userExpert?.text,
              status_approval: '',
            }
          }
        }),
        user_teams: this.busdevTeam?.map((val) => {
          let userExpert = this.approvalOptions.find(
            (obj) => obj.value == val.approval_id
          )
          return {
            id: val.approval_id,
            email: userExpert?.email,
            name: userExpert?.text,
            status_approval: '',
          }
        }),
        terms_id: f.term,
        created_by: JSON.parse(localStorage.getItem('profile')).id,
        created_by_email: JSON.parse(localStorage.getItem('profile')).email,
        created_name: JSON.parse(localStorage.getItem('profile')).userDetail
          .name,
        is_draft: saveDraft,
      }

      return payload
    },

    async sendAllNotifications(payload, projectId) {
      const currentUser = JSON.parse(localStorage.getItem('profile')).userDetail
        .name

      const approvalEmails = payload.user_approval.map((val) => {
        return this.sendEmailNotification({
          data: {
            to: val.email,
            name: `Dear, ${val.name}`,
            subject: `Project Plan ${this.editId ? 'Edited' : 'Created'}`,
            intro: `Project Planning ${this.editId ? 'Edited' : 'Created'}.`,
            outro: 'This email was automatically sent.',
            words: 'This email was automatically sent.',
            buttonText: 'Go to Dashboard',
            project_contract_id: projectId,
            url: 'busdev/dashboard',
            urlQuery: '',
          },
        })
      })

      const creatorEmail = {
        to: payload.created_by_email,
        name: `Dear, ${payload.created_name}`,
        subject: `Project Plan ${this.editId ? 'Edited' : 'Created'}`,
        instructions: `By: ${currentUser}`,
        intro: `Project Planning ${this.editId ? 'Edited' : 'Created'}.`,
        outro: 'This email was automatically sent.',
        words: 'This email was automatically sent.',
        buttonText: 'Go to Dashboard',
        project_contract_id: projectId,
        url: 'busdev/dashboard',
        urlQuery: '',
      }

      await this.sendEmailNotification({ data: creatorEmail })
      await Promise.all(approvalEmails)
    },

    async onSubmit(fromToggleEdit = false, saveDraft = false) {
      // Validasi manual untuk semua tab
      const validation = this.validateAllTabs()
      if (!validation.valid) {
        // Tampilkan alert dengan detail error
        this.$swal({
          title: 'Validation Error',
          html: `<div style="text-align: left;">
            <strong>Please check the following required fields:</strong>
            <br/><br/>
            ${validation.errors
              .map(
                (err) => `<strong>${err.tab}</strong>: ${err.fields.join(', ')}`
              )
              .join('<br/>')}
          </div>`,
          icon: 'warning',
          confirmButtonText: 'OK',
        })
        return
      }

      this.saving = true

      try {
        const payload = this.buildPayload(saveDraft)

        const response =
          this.editId && this.action === 'EDIT'
            ? await this.updateProjectContract({
                data: payload,
                id: Number(this.detailProjectContract?.id),
              })
            : await this.createShipmentPlanning({ data: payload })

        if ([500, 404, 403, 422].includes(response.status)) {
          throw new Error(
            response?.message ??
              response?.data?.message ??
              'Something went wrong!'
          )
        }

        if (!response?.data?.status) {
          throw new Error(response?.data?.message ?? 'Failed to save plan')
        }

        // const projectId =
        //   this.editId && this.action === 'EDIT'
        //     ? Number(this.detailProjectContract?.id)
        //     : Number(response?.data?.data?.id)

        const projectId = Number(response?.data?.data?.id)

        await this.handleDocumentsAndTender(projectId)
        // await this.sendAllNotifications(payload, projectId)

        this.showAlert(
          'Success!',
          `${this.editId ? 'Edit' : 'Create'} Plan Success.`,
          'success'
        )
        // Emit event to let parent refresh data and/or close modal
        // if (!fromToggleEdit) {
        if (typeof fromToggleEdit === 'boolean') {
          if (!fromToggleEdit) {
            this.$emit('refresh-data')
          }
        } else {
          this.$emit('refresh-data')
          this.$emit('close')
        }
      } catch (error) {
        this.showAlert('Oops.', error.message, 'error')
      } finally {
        this.saving = false
      }
    },
    validateAllTabs() {
      const errorsByTab = {
        GENERAL: [],
        'DETAIL SHIPMENT PLAN': [],
        'SUPPORT DOCUMENT': [],
      }
      let firstErrorTab = null

      // VALIDASI TAB GENERAL
      if (!this.form.subject) {
        errorsByTab['GENERAL'].push('Subject')
      }
      if (!this.form.company_id) {
        errorsByTab['GENERAL'].push('Company')
      }
      if (!this.form.priority) {
        errorsByTab['GENERAL'].push('Priority')
      }
      if (this.form.third_party && !this.form.third_party_company) {
        errorsByTab['GENERAL'].push('Third Party Company')
      }
      if (!this.form.contract_type_id) {
        errorsByTab['GENERAL'].push('Contract Type')
      }

      // Validasi Customer
      const hasCustomer =
        this.form.customerInfo?.customerActive?.id ||
        this.form.customerInfo?.customerProspect?.id ||
        this.form.customerInfo?.customer_active_id_pfat ||
        this.form.customerInfo?.customer_prospect_id_pfat
      if (!hasCustomer) {
        errorsByTab['GENERAL'].push('Customer (Active or Prospect)')
      }

      // Validasi Port - minimal 1 port dengan POL dan POD
      const hasValidPort = this.form.ports?.some(
        (p) => (p.pol || p.polOther) && (p.pod || p.podOther)
      )
      if (!hasValidPort) {
        errorsByTab['GENERAL'].push('Port (POL and POD)')
      }

      // Validasi Approval
      if (!this.approvals || this.approvals.length === 0) {
        errorsByTab['GENERAL'].push('Approval (at least 1)')
      }

      // VALIDASI TAB DETAIL SHIPMENT PLAN
      if (!this.form.detail_plan || this.form.detail_plan.length === 0) {
        errorsByTab['DETAIL SHIPMENT PLAN'].push('At least 1 shipment plan')
      } else {
        this.form.detail_plan.forEach((plan, index) => {
          const planErrors = []

          if (!plan.fleet_id) {
            planErrors.push('First Fleet')
          }
          if (!plan.cargo_type_id) {
            planErrors.push('Cargo Type')
          }
          if (!plan.terms_id) {
            planErrors.push('Term')
          }
          if (!plan.plan_quantity || Number(plan.plan_quantity) <= 0) {
            planErrors.push('Plan Quantity')
          }

          // Validasi POL
          const hasValidPOL = plan.pol?.some((p) => p.value || p.valueOther)
          if (!hasValidPOL) {
            planErrors.push('POL')
          }

          // Validasi POD
          const hasValidPOD = plan.pod?.some((p) => p.value || p.valueOther)
          if (!hasValidPOD) {
            planErrors.push('POD')
          }

          if (planErrors.length > 0) {
            errorsByTab['DETAIL SHIPMENT PLAN'].push(
              `Plan ${index + 1}: ${planErrors.join(', ')}`
            )
          }
        })
      }

      // Compile errors untuk response
      const errors = []
      Object.keys(errorsByTab).forEach((tab) => {
        if (errorsByTab[tab].length > 0) {
          errors.push({
            tab: tab,
            fields: errorsByTab[tab],
          })
          if (!firstErrorTab) {
            // Map tab name ke activeTab value
            if (tab === 'GENERAL') firstErrorTab = 'general'
            else if (tab === 'DETAIL SHIPMENT PLAN')
              firstErrorTab = 'shipment-plan'
            else if (tab === 'SUPPORT DOCUMENT') firstErrorTab = 'document'
          }
        }
      })

      return {
        valid: errors.length === 0,
        errors: errors,
        firstErrorTab: firstErrorTab,
      }
    },
    validateBeforeSubmit() {
      // Collect checks per tab to direct user to the right place
      const errors = []
      // GENERAL tab requireds
      if (!this.form.company_id)
        errors.push({ tab: 'general', field: 'Company' })
      if (this.form.third_party && !this.form.third_party_company)
        errors.push({ tab: 'general', field: 'Third Party Company' })
      if (!this.form.contract_type_id)
        errors.push({ tab: 'general', field: 'Contract Type' })
      if (
        !this.form.customerInfo?.customerActive?.id &&
        !this.form.customerInfo?.customerProspect?.id
      )
        errors.push({ tab: 'general', field: 'Customer (Active or Prospect)' })
      // Require cargo type and unit if applicable
      if (!this.form.cargo_type_id)
        errors.push({ tab: 'general', field: 'Cargo Type' })
      // Ports at least one row with pol/pod
      const ports = Array.isArray(this.form.ports) ? this.form.ports : []
      const hasValidPort = ports.some(
        (p) => (p.pol || p.polOther) && (p.pod || p.podOther)
      )
      if (!hasValidPort) errors.push({ tab: 'general', field: 'Port POL/POD' })

      // SHIPMENT PLAN tab minimal validation
      const plans = Array.isArray(this.form.detail_plan)
        ? this.form.detail_plan
        : []
      if (!plans.length) {
        errors.push({ tab: 'shipment-plan', field: 'At least 1 shipment plan' })
      } else {
        plans.forEach((pl, idx) => {
          if (!pl.cargo_type_id)
            errors.push({
              tab: 'shipment-plan',
              field: `Plan ${idx + 1} Cargo Type`,
            })
          if (!pl.terms_id)
            errors.push({ tab: 'shipment-plan', field: `Plan ${idx + 1} Term` })
          if (!pl.plan_quantity || Number(pl.plan_quantity) <= 0)
            errors.push({
              tab: 'shipment-plan',
              field: `Plan ${idx + 1} Quantity`,
            })
        })
      }

      if (errors.length) {
        const first = errors[0]
        const msg = `Missing/invalid: ${errors
          .slice(0, 4)
          .map((e) => e.field)
          .join(', ')}${errors.length > 4 ? '…' : ''}`
        return { valid: false, firstTabWithError: first.tab, message: msg }
      }
      return { valid: true }
    },
    async fetchCustomers() {
      try {
        const response = await hmacClient.get('/customers', {
          params: { limit: 999999 },
        })
        this.listCustomerActive = response.data.result
      } catch (error) {
        console.log(error)
      }
    },
    async fetchCustomerProspects() {
      try {
        const response = await hmacClient.get('/busdev/customer-prospects', {
          params: { limit: 999999 },
        })
        this.listCustomerProspect = response.result || []
        console.log(this.form, 'FORMMMM')
        if (
          this.form?.customerInfo?.customerActive &&
          typeof this.form.customerInfo?.customerActive !== 'object'
        ) {
          const found = response.result?.find(
            (el) =>
              Number(el.id) === Number(this.form.customerInfo.customerActive)
          )
          if (found) this.form.customerInfo.customerActive = found
        }
      } catch (error) {
        console.log(error)
      }
    },
    async loadDetailFromTable() {
      if (!this.editId) {
        this.hasLoadApprovalOrBusdevTeams = true
        return
      }
      try {
        const params = { id: this.editId }
        await this.fetchPaymentLists()
        // shipment-planning-table supports filtering by id
        const res = await this.fetchShipmentPlanningTable(params)
        const rows = res?.data?.data?.data || []
        const detail =
          rows.find((r) => Number(r.id) === Number(this.editId)) || rows[0]
        if (!detail) {
          this.hasLoadApprovalOrBusdevTeams = true
          return
        }

        // Map API fields to form
        const d = detail
        this.is_draft = d.is_draft
        this.form.subject = d.subject
        this.form.priority = d.prioritize ? Number(d.prioritize) : this.form.priority
        this.localIsDetail = d.is_draft ? false : !!this.isDetail
        this.dataDetailShipmentPlan = d
        this.form.id = d.id
        this.form.company = d.company
        this.form.cargo_type = d.cargo_type
        this.form.project_sub_id = d.project_sub_id
        this.form.company_id = d.company_id || null
        this.form.fleet_ownership = d.fleet_ownership || 'own-ship'
        this.form.detail_project_stage_id = d.detail_project_stage_id
        this.form.third_party = !!d.third_party
        this.form.third_party_company = d.third_party_company || ''
        // Map fleet_type_ids to option objects from fleetTypeOptions
        if (Array.isArray(d.fleet_type_ids)) {
          this.form.fleet_type_ids = d.fleet_type_ids
            .map((id) => this.fleetTypeOptions.find((opt) => opt.value === id))
            .filter(Boolean)
        } else if (d.fleet_type_id) {
          const opt = this.fleetTypeOptions.find(
            (o) => o.value === d.fleet_type_id
          )
          this.form.fleet_type_ids = opt ? [opt] : []
        } else {
          this.form.fleet_type_ids = []
        }
        this.prevFleetTypeIds = [...this.form.fleet_type_ids]
        // period and laycan arrays
        this.form.period = [d.periode_start, d.periode_end].filter(Boolean)
        this.form.contract_type_id = d.contract_type_id || null
        this.form.contract_type = d.contract_type || null
        this.form.is_pfa = d.is_pfa === 1
        this.form.cargo_type_id = d.cargo_type_id || null
        this.form.unit = d.unit || ''
        this.form.term = d.terms_id || ''
        this.form.termDescription =
          d.terms_remarks || d?.terms?.description || ''
        this.form.laycan = [d.laycan_start, d.laycan_end].filter(Boolean)
        this.form.distance = d.distance || 0
        this.form.currency_id = d.currency_id || 'IDR'
        this.form.currencyRate = d.currency_rate || 0
        this.form.freightRate = d.freight_rate_est || 0
        this.form.isPpn = d.ppn === 'include'
        this.form.remarks = d.remarks || ''
        this.form.spal_process = d.spal_process
        this.form.project_name = d.project_name || d.project || ''
        this.form.shipment_plan_number = d.shipment_plan_number || ''

        this.form.tenderPic = d?.project_tender?.pic || ''
        this.form.tenderUrl = d?.project_tender?.url || ''
        this.form.tenderAttachment = d?.project_tender?.file || []
        this.form.tenderDescription =
          d?.project_tender?.description_of_tender || ''

        // Approvals: map only in detail mode
        if (this.localIsDetail && Array.isArray(d.user_approval)) {
          this.approvals = d.user_approval.map((u) => ({
            user: u.id,
            name: u.name,
            text: u.name,
            email: u.email,
            status_approval: u.status_approval || '',
            approval_id: u.id,
          }))
        } else {
          this.approvals = []
        }

        if (this.localIsDetail && Array.isArray(d.user_teams)) {
          this.busdevTeam = d.user_teams.map((u) => ({
            user: u.id,
            name: u.name,
            text: u.name,
            email: u.email,
            status_approval: u.status_approval || '',
            approval_id: u.id,
          }))
        } else {
          this.busdevTeam = []
        }

        // Support Documents: load for detail to enable download list
        if (this.localIsDetail && Array.isArray(d.project_document)) {
          this.form.documents = d.project_document.map((doc) => {
            const fileUrl = this.buildFileUrl(doc.url)
            const fileName =
              doc.filename ||
              (typeof fileUrl === 'string' ? fileUrl.split('/').pop() : '')
            return {
              id: doc.id,
              fileName: fileName,
              fileUrl: doc.url,
              extension: doc.extension,
              size: doc.size,
              shipmentPlanDetailNumber: doc?.shipment_plan_number,
            }
          })
        }

        // customer info: hide fields on detail; set from active/prospect lists
        // priority: customer_id (active) then customer_prospect_id_pfat (prospect)
        const setCustomerActive = () => {
          if (d.customer_active_id_pfat) {
            this.form.customerInfo.customerType = 'active'
            const found = this.listCustomerActive?.find(
              (el) => Number(el.id) === Number(d.customer_active_id_pfat)
            )
            if (found) this.form.customerInfo.customerActive = found
          } else if (d.customer_prospect_id_pfat) {
            this.form.customerInfo.customerType = 'prospect'
            const found = this.listCustomerProspect?.find(
              (el) => Number(el.id) === Number(d.customer_prospect_id_pfat)
            )
            if (found) this.form.customerInfo.customerActive = found
          }
        }
        // ensure lists are available then set
        if (!this.listCustomerActive?.length) await this.fetchCustomers()
        if (!this.listCustomerProspect?.length)
          await this.fetchCustomerProspects()
        setCustomerActive()

        // Ports pol/pod structure [{value, valueOther}]
        const normLoc = (arr) =>
          Array.isArray(arr) && arr.length
            ? arr
            : [{ value: '', valueOther: '' }]
        this.form.ports =
          d.pol || d.pod
            ? (d.pol || []).map((p, i) => ({
                pol: p?.value || null,
                polOther: p?.valueOther || '',
                pod: d.pod?.[i]?.value || null,
                podOther: d.pod?.[i]?.valueOther || '',
              }))
            : [{ pol: null, polOther: '', pod: null, podOther: '' }]

        const findDetailShipmentPlanPaymentList = (id) => {
          return this.formState?.paymentList?.find((el) => {
            if (el.shippment_plan) {
              const paymentListDetailPlan = JSON.parse(el.shippment_plan)
              let deleted = false
              for (let i = 0; i < paymentListDetailPlan.length; i++) {
                if (
                  paymentListDetailPlan[i].shipment_plan_detail_number === id
                ) {
                  deleted = true
                  break
                }
              }
              return deleted
            } else return false
          })
        }
        // Detail plan minimal mapping so totals show; if API provides detail, map it
        if (
          Array.isArray(d.project_contract_plan) &&
          d.project_contract_plan.length
        ) {
          this.form.detail_plan = d.project_contract_plan.map((it, index) => ({
            shipment_plan_detail_number: it.shipment_plan_detail_number,
            status: it.status || 'plan',
            description: it.description || '',
            fleet_id: it.fleets?.[0]?.vehicle_id || null,
            second_fleet_id: d?.second_fleets?.[index]?.vehicle_id || null,
            fleet_type_id: it.fleet_type_id || null,
            cargo_type_id: it.cargo_type_id || d.cargo_type_id || null,
            terms_id: it.terms_id || d.terms_id || null,
            terms_remarks: it.terms_remarks || '',
            ports:
              it.pol || it.pod
                ? (it.pol || []).map((p, i) => ({
                    pol: p?.value || null,
                    polOther: p?.valueOther || '',
                    pod: it.pod?.[i]?.value || null,
                    podOther: it.pod?.[i]?.valueOther || '',
                  }))
                : [{ pol: null, polOther: '', pod: null, podOther: '' }],
            pod: it.pod || [],
            pol: it.pol || [],
            shipment: it.shipment || 0,
            eta_pol: it.eta_pol || null,
            eta_pod: it.eta_pod || null,
            plan_quantity: it.plan_quantity || 0,
            remarks: it.remarks || '',
            acceptance_date: it.acceptance_date
              ? moment(it.acceptance_date).format('YYYY-MM-DD HH:mm')
              : null,
            draught_type: it.draught_type || 'draught_survey_loading',
            fleet_ownership: it.fleet_ownership || null,
            id: it.id,
            can_delete: findDetailShipmentPlanPaymentList(
              it.shipment_plan_detail_number
            )
              ? false
              : true,
          }))
        } else {
          // fallback minimal row so UI shows values
          this.form.detail_plan = [
            {
              status: 'plan',
              description: d.project_name || '',
              fleet_id: d.fleets?.[0]?.vehicle_id || null,
              fleet_type_id: d.fleet_type_id || null,
              cargo_type_id: d.cargo_type_id || null,
              terms_id: d.terms_id || null,
              terms_remarks: d.terms_remarks || '',
              ports: normLoc(d.pol),
              shipment: d.shipment || 0,
              eta_pol: null,
              eta_pod: null,
              plan_quantity: d.total_quantity || 0,
              remarks: d.remarks || '',
              acceptance_date: null,
              draught_type: 'draught_survey_loading',
              fleet_ownership: d.fleet_ownership || null,
              id: d.id || null,
            },
          ]
        }

        this.formState.tripDocuments = d?.trip_document?.map((it) => ({
          documentName: it.name_document,
          planId: it?.plan_id,
          detailTripNumber: this.form.detail_plan.find(
            (o) => o.id === it?.plan_id
          )?.shipment_plan_detail_number,
          fileName: it?.trip_attachment?.[0]?.file_name,
          fileUrl: it?.trip_attachment?.[0]?.file_url,
          file: null,
          id: it.id,
        }))
        this.hasLoadApprovalOrBusdevTeams = true
      } catch (e) {
        console.log('Failed load detail', e)
      }
    },
    buildFileUrl(url) {
      if (!url) return ''
      const isAbsolute = /^https?:\/\//i.test(url)
      if (isAbsolute) return url
      const base =
        process.env.VUE_APP_API_BUSDEV_BASE_URL || window.location.origin
      const sep = base.endsWith('/') ? '' : '/'
      const path = url.startsWith('/') ? url.slice(1) : url
      return `${base}${sep}${path}`
    },
    toggleEdit() {
      if (!this.localIsDetail) {
        this.onSubmit(true)
      }
      this.localIsDetail = !this.localIsDetail
    },
    projectIdForSidebar() {
      // Prefer saved editId; fallback to newly created id stored on form if available
      return this.editId || this.form?.id || null
    },
    async fetchPaymentLists() {
      try {
        if (!this.editId) return
        const res = await hmacClient.get('/busdev/payment-lists', {
          params: { project_contract_id: this.editId },
        })
        const items =
          res?.data?.result || res?.data?.data || res?.rows || []
        this.$set(this.formState, 'paymentList', items)
      } catch (e) {}
    },
  },
  mounted() {
    // set local detail flag from prop
    this.fetchCustomers()
    this.fetchCustomerProspects()
    this.getCurrency()
    this.fetchDataUserExpert()
    this.getVehicleType()
    this.getCargoType()
    this.getPortList()
    this.getListProjectTerms()
    this.fetchFleets()
    this.fetchFleetTypes()
    this.getTerms()
    this.getContractTypes()
    this.getListProjectStage()
    // load detail if editId provided
    this.loadDetailFromTable()
  },
  watch: {
    editId(n, o) {
      if (n && n !== o) this.loadDetailFromTable()
      else this.hasLoadApprovalOrBusdevTeams = true
    },
  },
}
</script>

<style scoped>
::v-deep .section-title {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #334697;
  background: blue;
  margin-bottom: 32px;
}

::v-deep .section-title h5 {
  color: #273469;
  font-weight: 600;
  background: white;
  position: absolute;
  top: -12px;
  padding-right: 20px;
}

.text-red {
  color: red;
}

.font-semibold {
  font-weight: 600;
}
</style>
